module.exports = __webpack_public_path__ + "static/media/kalja.3b6b740a.png";